var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 93,
    viewBox: "0 0 86 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1 2.59985H81.2C82.3 2.59985 83.2 3.49884 83.2 4.59759V60.3345C83.2 61.633 82.6 62.8317 81.6 63.5309L45.5 90.2007C44.1 91.1996 42.2 91.1996 40.7 90.2007L4.6 63.6308C3.6 62.8317 3 61.633 3 60.4344V4.59759C3 3.49884 3.9 2.59985 5 2.59985H43.1Z",
    stroke: "#D89F5B",
    strokeWidth: 4.0121,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2 28.8701C78.2 23.676 73.9 17.0835 72.1 14.1867C69.2 9.69184 65.1 12.189 62.5 16.9836C59.9 21.7782 31.5 83.4084 31.5 83.4084",
    stroke: "#D89F5B",
    strokeWidth: 4.0121,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2001 37.2605C74.4001 34.3638 72.6001 22.0777 69.2001 30.5681C67.6001 34.5635 46.1001 89.7011 46.1001 89.7011",
    stroke: "#D89F5B",
    strokeWidth: 4.0121,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7001 79.9124C29.6001 75.3176 33.7001 65.8283 33.7001 57.4378C33.7001 51.5445 37.7001 44.1529 38.6001 42.0552C38.7001 41.8555 38.5001 41.6557 38.3001 41.7556L10.3001 49.7465C10.2001 49.7465 10.2001 49.9463 10.3001 49.9463C11.6001 50.6455 15.8001 53.742 16.6001 57.3379C17.4001 61.4333 14.9001 67.8261 13.8001 70.2233",
    stroke: "#D89F5B",
    strokeWidth: 4.0121,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5999 63.531C45.0999 64.2302 46.0999 65.7285 46.0999 67.4266C46.0999 69.8239 44.1999 71.7217 41.7999 71.7217C41.0999 71.7217 40.4999 71.522 39.8999 71.3222",
    stroke: "#D89F5B",
    strokeWidth: 2.0061,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6 52.5432C50.1 53.2424 51.1 54.7407 51.1 56.4388C51.1 58.8361 49.2 60.7339 46.8 60.7339C46.2 60.7339 45.6 60.6341 45 60.3344",
    stroke: "#D89F5B",
    strokeWidth: 2.0061,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6001 41.7556C55.1001 42.4548 56.1001 43.9531 56.1001 45.6512C56.1001 48.0485 54.2001 49.9463 51.8001 49.9463C51.2001 49.9463 50.6001 49.8465 50.1001 49.5468",
    stroke: "#D89F5B",
    strokeWidth: 2.0061,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSax);
export default __webpack_public_path__ + "static/media/sax.03ba1702c2e3a41b676ab9617abcd1b1.svg";
export { ForwardRef as ReactComponent };